import { Component, inject, input } from '@angular/core';
import { Conversation, PrivacyLevel } from '@vendasta/protos/meeting_analysis/v1';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MEETING_ANALYSIS_NAMESPACE_NAME_INJECTION_TOKEN$ } from '@galaxy/meeting-analysis/static';

@Component({
  selector: 'meeting-analysis-visibility',
  template: `@if (namespaceName$ | async; as name) {
    @if (conversation()?.privacyLevel === PrivacyLevel.PRIVACY_LEVEL_PRIVATE) {
      <span class="visibility-container">
        <span>{{ 'VISIBILITY.PRIVATE' | translate }} <mat-icon>lock</mat-icon></span>
      </span>
    } @else if (conversation()?.privacyLevel === PrivacyLevel.PRIVACY_LEVEL_UNLISTED) {
      <span class="visibility-container">
        <span>{{ 'VISIBILITY.UNLISTED_V2' | translate: { namespaceName: name } }}</span>
        <mat-icon>lock_open</mat-icon>
      </span>
    } @else {
      <span class="visibility-container">
        <span>{{ 'VISIBILITY.OPEN' | translate: { namespaceName: name } }}</span>
        <mat-icon>group</mat-icon>
      </span>
    }
  }`,
  styleUrls: ['./visibility.component.scss'],
  imports: [CommonModule, TranslateModule, MatIconModule],
})
export class VisibilityComponent {
  PrivacyLevel = PrivacyLevel;
  conversation = input<Conversation>();

  namespaceName$ = inject(MEETING_ANALYSIS_NAMESPACE_NAME_INJECTION_TOKEN$);
}
